import React from 'react'

const FunFact = () => {
  return (
    <section className="fun-fact-section">
  <div className="auto-container">
    <div className="fact-counter">
      <div className="row clearfix">
        {/*Column*/}
        <div className="counter-column col-lg-3 col-md-6 col-sm-12 wow zoomIn">
          <div className="inner-box">
            <div className="count-box">
              <span className="icon bg-1" />
              <span className="count-text" data-speed={3000} data-stop={94}>
                0
              </span>
            </div>
            <span className="counter-title">Meeting Tickets Affirmed </span>
          </div>
        </div>
        {/*Column*/}
        <div
          className="counter-column col-lg-3 col-md-6 col-sm-12 wow zoomIn"
          data-wow-delay="300ms"
        >
          <div className="inner-box">
            <div className="count-box">
              <span className="icon bg-2" />
              <span className="count-text" data-speed={3000} data-stop={28}>
                0
              </span>
            </div>
            <span className="counter-title">Universally Capable Speakers </span>
          </div>
        </div>
        {/*Column*/}
        <div
          className="counter-column col-lg-3 col-md-6 col-sm-12 wow zoomIn"
          data-wow-delay="600ms"
        >
          <div className="inner-box">
            <div className="count-box">
              <span className="icon bg-3" />
              <span className="count-text" data-speed={3000} data-stop={35}>
                0
              </span>
            </div>
            <span className="counter-title">
              Food Espresso and Studio Breaks{" "}
            </span>
          </div>
        </div>
        {/*Column*/}
        <div
          className="counter-column col-lg-3 col-md-6 col-sm-12 wow zoomIn"
          data-wow-delay="900ms"
        >
          <div className="inner-box">
            <div className="count-box">
              <span className="icon bg-4" />
              <span className="count-text" data-speed={3000} data-stop={65}>
                0
              </span>
            </div>
            <span className="counter-title">
              Supporters Prepared To Take an interest
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default FunFact